import { createApi } from '@reduxjs/toolkit/query/react';

import IProfile from '@/interfaces/profile';

import { axiosBaseQuery } from './query';

export const userApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'userApi',
  tagTypes: ['user'],
  endpoints(build) {
    return {
      getUser: build.query<IProfile, void>({
        query: () => ({
          method: 'GET',
          url: '/user',
          formatResponse: res => {
            return res.data.data;
          }
        })
      }),
      updateUser: build.mutation<void, IProfile>({
        query: user => ({
          method: 'PUT',
          url: '/user',
          data: user,
          formatResponse: res => {
            return res.data.data;
          }
        }),
        async onQueryStarted(profile, { dispatch, queryFulfilled }) {
          const { data } = await queryFulfilled;

          dispatch(
            userApi.util.updateQueryData('getUser', undefined, draft => {
              Object.assign(draft, data);
            })
          );
        }
      })
    };
  }
});

export const { useGetUserQuery, useUpdateUserMutation } = userApi;
